/* eslint-disable no-unused-expressions */
import React from 'react';
import {connect} from 'react-redux';
import {QuestionListDto} from '../Dtos/QuestionListDto';
import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../HttpService/HttpService';
import {registerLocale} from 'react-datepicker';
import pl from 'date-fns/locale/pl'
import 'react-datepicker/dist/react-datepicker.css';
import {AnswerDetail} from '../AnswerDetail/AnswerDetail';
import {Waiter} from '.././WaitingSign/Waiting';
import {ControlDetailInfo} from '../ControlDetailInfo/ControlDetailInfo';
import {sendLog} from '../HttpService/SendLog';
import {getControllingTeam} from '../ManageControlCommons/ManageControlCommons';
import PdfControlInfo from '../PdfPostControl/PdfControlInfo';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import {PDFDownloadLink} from '@react-pdf/renderer';
import {generateControlListDocx} from '.././DocxTemplate/ControlListDocx';
import PopUp from "../PopUp/PopUp";
import {mapNewAnswersToQuestion} from "../documents/helpers";
import {AuditDetail} from "../AuditDetail/AuditDetail";

export const GET_CONTROL_LIST_DATA_REQUESTED = 'GET_CONTROL_LIST_DATA_REQUESTED';
export const GET_CONTROL_LIST_DATA_DONE = 'GET_CONTROL_LIST_DATA_DONE';
export const GET_CONTROL_LIST_DATA_FAILED = 'GET_CONTROL_LIST_DATA_FAILED';

class ControlListInControlDetail extends React.Component {
	/* jshint expr: true */
	controlId;

	constructor(props) {
		super(props);
		this.state = {
			controlId: null,
			isWaiting: true,
			isLocked: true,
			remarksOpened: false,
			questionListData: null,
			showPopup: false,
			showCancelTab: false,
			showPrepPostContInfo: false,
			showPrepPostContNote: false,
			controlData: null,
			controlResponse: [],
			controlledParties: [],
			controlledPlaces: [],
			controlledOrders: [],
			controlledWops: [],
			controlledValue: '',
			isSaved: '',
			answers: null
		}
		this.handleClosePopUp = this.handleClosePopUp.bind(this);

	}

	handleClosePopUp() {
		this.setState({showPopup: false});
	}

	componentDidMount() {
		this.controlId = this.props.match.params.controlId;
		this.fetchControlData(this.controlId, this.props.source);
	}

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	goBack = () => {
		this.props.history.goBack();
	};
	handleChange = date => {
		this.setState({
			startDate: date
		});
	};

	handleCloseInfoTab = () => {
		this.setState({
			showPrepPostContInfo: false
		});
	};

	fetchControlData = (controlId, source) => {
		const urlControl = source === "my_controls" ? PropertyBucket.getMyControlDetailByControlId(controlId) : PropertyBucket.getPostControlDetailByControlId(controlId);
		let controlResponse = httpService.getService(urlControl, 'GET');
		controlResponse.then(data => {
			mapNewAnswersToQuestion(data)
			this.controlId = data.id;
			this.setState({
				answers: data.answers,
				controlData: data,
				questionListData: data.questionList,
				blocksData: data.questionList.blocksInList,
				isWaiting: false
			})

		}).catch(error => {
			this.setState({
				showPopup: true,
				popUp: {
					notification: error.message || 'Nieznany błąd.',
					type: 'error',
					title: 'Błąd'
				}
			})
		});
	};


	handleSubmit = (event) => {
		event.preventDefault();
	};


	listQuestions = (questions) => {
		let rows = [];
		if (questions) {
			questions.forEach(function (question, index) {
				let val = <p key={index} className='questionRow'>{question.question}</p>;
				rows.push(val);
			});
			return rows;
		} else {
			return 'Nie ma pytań';
		}
	};


	getControlData = (item) => {
		item.beneficiary = item.project.beneficiary;
		item.controlPlace = item.project.place;
		item.term = item.dateFrom + ' - ' + item.dateTo;
		item.kind = '';
		item.controlTeam = '';
		item.dictionaryEntries.forEach(function (value, index) {
			if (value.dictNumber === 1) {
				item.type = value.description;
			}
			if (value.dictNumber === 2) {
				item.mode = value.description;
			}
			if (value.dictNumber === 3) {
				item.kind += value.description + ', ';
			}
		});
		item.kind = item.kind.substr(0, (item.kind.length - 2));

		// prepare info about control team
		getControllingTeam(item);

		return item;
	};
	saveAnswers = () => {
		let questionListData = this.state.questionListData;
		let questionListDto = new QuestionListDto();
		questionListDto.listId = questionListData.listId;
		let blocks = questionListData.blocks;
		blocks.forEach(function (block, index) {

		});

	};


	controlInfoItem = (label, value) => {
		return (<div className='row mt-3'>
			<div className='col-md-3 input-label'>{label}:</div>
			<div className='col-md-9'>{value}</div>
		</div>)
	};

	createPdf = (controlData) => {
		return (
			<PdfControlInfo control={controlData} infoNumber={controlData.number} />
		)
	};

	printControlHeader() {
		let questionListData = this.state.questionListData;
		let controlData = this.state.controlData;
		this.state.isWaiting === false ? this.getControlData(controlData) : null;
		let header;
		document.title = `e-Kontrole | Lista sprawdzająca dla kontroli: ${controlData?.number}`;

		if (questionListData && controlData && controlData.controlledParties) {
			const fileName = 'eKontrole-' + controlData.number + '.pdf';
			
			header = <div id='listContainer'>
				<div>
					{controlData?.postControlDocuments?.length ? (
						<button className='btn success-btn' id='pdf_img_container' onClick={() => {sendLog(null, null, fileName)}}>
							<span className="sr-only">Pobierz PDF</span>
							<PDFDownloadLink document={this.createPdf(controlData)} fileName={fileName}>
								{({loading}) => (loading ? '' : (
									<>
										<PictureAsPdfIcon style={{color: '#0d47a1', fontSize: 46}}/>
										<span className="sr-only">Kliknij, aby pobrać PDF</span>
									</>
								))}
							</PDFDownloadLink>
						</button>
					) : (
					<>
						<button type='button' onClick={() => generateControlListDocx(controlData, controlData.listValidated)} className='doc-button'>
							<img
								className='ico-doc'
								src='/icoDoc.svg'
								alt='Pobierz dokument .docx'
							/>
						</button>
						{!controlData.listValidated && <span className='red h5'>WERSJA ROBOCZA</span>}
					</>)}
					<button className='btn save-btn' id='plus_img_container' onClick={this.goBack}><i data-v-db6946bc=''
					                                                                                  aria-hidden='true'
					                                                                                  className='v-icon material-icons theme--light v-list-text'>arrow_back</i><span>WRÓĆ</span>
					</button>
					<h3 className='mb-5'>Lista sprawdzająca dla kontroli: {controlData.number}</h3>
				</div>
				<ControlDetailInfo control={controlData}/>
			</div>
		}else {
			header = <div id='listContainer'>
				<div>
					<button className='btn save-btn' id='plus_img_container' onClick={this.goBack}><i data-v-db6946bc=''
																									  aria-hidden='true'
																									  className='v-icon material-icons theme--light v-list-text'>arrow_back</i><span>WRÓĆ</span>
					</button>
				</div>
			</div>
		}
		return header;
	}

	printBlockSection() {
		let questionList = this.state.questionListData;
		let section = [];
		let answers = this.state.answers;
		section.push(<AnswerDetail key={questionList.name} questionList={questionList} answers={answers}/>);
		return section;
	}

	render() {
		registerLocale('pl', pl);
		//let blocksData = this.state.blocksData;
		let list = this.state.questionListData;
		let popUp;
		this.state.showPopup ?
			popUp = <PopUp
				type={this.state.popUp.type}
				title={this.state.popUp.title}
				notification={this.state.popUp.notification}
				closePopUp={this.handleClosePopUp}
			/> : null;
		
		return (
			<div>
				<div>
					{this.printControlHeader()}
					{list ? <h4 id='blocks_section_title'>Bloki z pytaniami: </h4> : null}
					{list ? this.printBlockSection(list) : null}
					{
						(this.state.isWaiting || this.state.controlData?.controlStatus === "Planowana") ? null :
							<div className='controlListBlocks'>
								<h4 className='mt-4'>Dane audytowe:</h4>
								{<AuditDetail 
									auditData={{
									createdOn: this.state.controlData?.listCreatedOn,
									createdByLogin: this.state.controlData?.listCreatedByLogin,
									createdBy: this.state.controlData?.listCreatedBy,
									updatedOn: this.state.controlData?.listUpdatedOn,
									updatedByLogin: this.state.controlData?.listUpdatedByLogin,
									updatedBy: this.state.controlData?.listUpdatedBy,
									}}>
								</AuditDetail>}
							</div>
					}
					{popUp}
				</div>
				<div id='waiter'><Waiter loading={this.state.isWaiting}/></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {
		//blocksData: qtype => dispatch(actionsBlocks.getData(qtype))
	}
};

export const ControlListInControlDetailProvider = connect(mapStateToProps, mapDispatchToProps)(ControlListInControlDetail);



